import { Box } from '@mui/material';

const PageContent = ({ children, contentKey }) => (
	<Box
		key={contentKey}
		sx={{
			animation: 'pageEnter 0.45s cubic-bezier(0.22, 1, 0.36, 1)',
			'@keyframes pageEnter': {
				from: {
					opacity: 0,
					transform: 'translateY(12px)',
				},
				to: {
					opacity: 1,
					transform: 'translateY(0)',
				},
			},
		}}
	>
		{children}
	</Box>
);

export default PageContent;
